




























































































import {
  defineComponent,
  onBeforeMount,
  reactive,
  toRefs,
} from "@vue/composition-api";
import { HttpPOST, ValidateEmail } from "@/code/Utils";
import Alerts, { AlertType } from "../code/alerts";

export default defineComponent({
  name: "Registrarse",
  setup(props, context) {
    const data = reactive({
      email: "",
      cuil: "",
      name: "",
      lastname: "",
      businessname: "",
      password: "",
    });

    const Register = async () => {
      if (
        data.email.trim() !== "" &&
        data.cuil.trim() !== "" &&
        data.name !== "" &&
        data.lastname !== "" &&
        data.businessname !== "" &&
        data.password !== ""
      ) {
        if (!ValidateEmail(data.email)) {
          Alerts.Throw(
            "Debe ingresar un email valido.",
            AlertType.Danger,
            false,
            6000
          );
          return;
        }

        const xml = `<?xml version="1.0" encoding="utf-8"?>
                      <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                        <soap12:Body>
                          <RegistrarUsuDDJJ xmlns="http://tempuri.org/">
                            <cuit>${data.cuil}</cuit>
                            <mail>${data.email}</mail>
                            <password>${data.password}</password>
                            <nombre>${data.name}</nombre>
                            <apellido>${data.lastname}</apellido>
                            <razonsocial>${data.businessname}</razonsocial>
                          </RegistrarUsuDDJJ>
                        </soap12:Body>
                      </soap12:Envelope>`;

        const result = (await HttpPOST(xml, null)) as XMLHttpRequest;

        if (result.statusText === "OK") {
          data.cuil = "";
          data.email = "";
          data.name = "";
          data.lastname = "";
          data.businessname = "";
          data.password = "";
          Alerts.Throw(
            `Su solicitud fué enviada. Próximamente recibirá un email con la confirmación del usuario.<br><br>Recuerde: Podrá ingresar con el Cuil/ email y password, sin embargo hasta que no le sea confirmado el usuario no podrá declarar ventas.<br><br><a href="./"><b>Volver</b></a>`,
            AlertType.Info,
            false,
            10000
          );
        } else {
          Alerts.Throw(
            `Ocurrió un error al enviar el mail de registro.<br><br>Por favor intente de nuevo en unos minutos.`,
            AlertType.Danger,
            false,
            10000
          );
        }
      } else {
        Alerts.Throw(
          "Por favor, verifique los campos para ingresar.",
          AlertType.Danger,
          false,
          6000
        );
      }
    };

    const ShowHidePassword = (ATagid: string, Inputid: string) => {
      const a = document.getElementById(ATagid);
      const icon = document.querySelector(`#${ATagid} i`);
      const input = document.getElementById(Inputid);
      const atr = input.getAttribute("type");
      const contains = icon.classList.contains("fa-eye-slash");
      const title = a.getAttribute("title");
      a.setAttribute(
        "title",
        title == "Mostrar Contraseña"
          ? "Ocultar Contraseña"
          : "Mostrar Contraseña"
      );
      icon.classList.remove(contains ? "fa-eye-slash" : "fa-eye");
      icon.classList.add(contains ? "fa-eye" : "fa-eye-slash");
      input.setAttribute("type", atr == "password" ? "text" : "password");
    };

    return {
      ...toRefs(data),
      Register,
      ShowHidePassword,
    };
  },
});
